import { render, staticRenderFns } from "./image-card.vue?vue&type=template&id=4d4a47a4&scoped=true"
import script from "./image-card.vue?vue&type=script&lang=js"
export * from "./image-card.vue?vue&type=script&lang=js"
import style0 from "./image-card.vue?vue&type=style&index=0&id=4d4a47a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4a47a4",
  null
  
)

export default component.exports